/* eslint-disable react/jsx-indent */
import React, { Component } from 'react'
import { Card, CardBody, Media, Row, Col } from 'reactstrap'

class FinResultCard extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { revenue_title, expense_title, result_title, revenue_value, expense_value, result_value, margin, roi, title } = this.props
    let ptBR = Intl.NumberFormat("pt-BR", {
      style: "decimal",
      currency: "BRL",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    })
    return (
      <Card>
        <CardBody>
          <Row>
            <Col>
              <h4 className="card-title mb-4">{title}</h4>
            </Col>
          </Row>

          <Media>
            <Media body className="overflow-hidden">
              <p className="text-truncate font-size-14 mb-2">{revenue_title}</p>
              <h4 className="mb-0">{ptBR.format(revenue_value)}</h4>
            </Media>
            <Media body className="overflow-hidden">
              <p className="text-truncate font-size-14 mb-2">{expense_title}</p>
              <h4 className="mb-0">{ptBR.format(expense_value)}</h4>
            </Media>
            <Media body className="overflow-hidden">
              <p className="text-truncate font-size-14 mb-2">{result_title}</p>
              <h4 className="mb-0">{ptBR.format(result_value)}</h4>
            </Media>
          </Media>
        </CardBody>
        <CardBody className="border-top py-3">
        <div className="text-truncate">
          <span className={(margin)>0 ? 'badge-success badge-pill font-size-11 mr-1' : 'badge-danger badge-pill font-size-11 mr-1'}>
          {ptBR.format(Math.abs(margin)*100)} % <i className={margin>0 ? ('ri-arrow-up-fill') : ('ri-arrow-down-fill')} />
          </span>
          <span className="text-muted ml-1">
            de margem de lucro
          </span>
        </div>
        <div className="text-truncate">
          <span className={(roi)>0 ? 'badge-success badge-pill font-size-11 mr-1' : 'badge-danger badge-pill font-size-11 mr-1'}>
            {ptBR.format(Math.abs(roi)*100)} % <i className={roi>0 ? ('ri-arrow-up-fill') : ('ri-arrow-down-fill')} />
          </span>
          <span className="text-muted ml-1">
            de retorno sobre o investimento
          </span>
        </div>
        </CardBody>
      </Card>
    )
  }
}
export default FinResultCard
